/**
 * Воронка оплаты открывается в НОВОЙ вкладке: студийная остаётся как была —
 * черновик блока цел, прогон продолжает опрашиваться.
 *
 * Мест вызова два — сразу после заведения транзакции и повторное открытие с
 * шага ожидания (первый попап летит уже после `await` и в Safari блокируется),
 * поэтому набор параметров окна живёт одной строкой, а не двумя копиями.
 */
export const openPaymentWindow = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer')
}
